import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT } from 'listing-details/constants';

export const trackClickSavedPropertyWidgetCard = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'homepage',
        eventAction: 'clickthrough',
        eventLabel: 'saved property'
    });
};

export const trackClickSeeAllSavedProperties = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'homepage',
        eventAction: 'clickthrough',
        eventLabel: 'see all saved properties'
    });
};

export const trackSavedPropertiesWidgetLoad = (
    featureIsActive: boolean,
    userIsSignedIn: boolean,
    hasSavedProperties: boolean
) => {
    let eventLabel = featureIsActive ? 'variation' : 'original';
    if (featureIsActive && !hasSavedProperties)
        eventLabel = 'no saved properties';
    if (!userIsSignedIn) eventLabel = 'not signed in';
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'optimizely',
        eventAction: 'lex-323_saved_properties_widget',
        eventLabel
    });
};
